import { useBrand } from "../context/BrandContext";

function Section({ title, children }) {
    return (
        <section className="mb-10">
            <h2 className="font-display text-xl font-bold mb-3 pb-2 border-b border-line">{title}</h2>
            <div className="space-y-3 text-sm leading-relaxed text-dim">{children}</div>
        </section>
    );
}

export default function TermsPage() {
    const brand = useBrand();
    return (
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="terms-page">
            <div className="panel p-8 sm:p-10 mb-12">
                <span className="eyebrow text-accent">Legal</span>
                <h1 className="font-display text-3xl sm:text-5xl font-bold mt-3 inline-block border-b-[3px] border-accent pb-3">Terms of Use</h1>
                <p className="font-mono text-xs text-dim mt-4">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
            </div>

            <Section title="1. Acceptance of Terms">
                <p>By accessing {brand.domain} or creating an account, you agree to be bound by these Terms of Use. If you do not agree, please do not use the site.</p>
            </Section>
            <Section title="2. Editorial Content">
                <p>News content on this site is aggregated from The Guardian Content API and is provided for general information only. It does not constitute financial, investment, tax, or legal advice. Always consult a qualified professional before making financial decisions.</p>
            </Section>
            <Section title="3. Accounts">
                <p>You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. You must provide accurate registration information.</p>
            </Section>
            <Section title="4. SMS Messaging Terms">
                <p>By opting in to SMS, you agree to receive recurring automated marketing and/or transactional text messages from {brand.site_name} at the number provided. Consent is not a condition of purchase.</p>
                <p>Message frequency varies and may be up to 4 messages per week. Message and data rates may apply. Reply STOP to cancel at any time; you will receive a confirmation message. Reply HELP for help. Carriers are not liable for delayed or undelivered messages.</p>
            </Section>
            <Section title="5. Acceptable Use">
                <p>You agree not to misuse the site, attempt to gain unauthorized access, scrape content at scale, or interfere with its normal operation.</p>
            </Section>
            <Section title="6. Intellectual Property">
                <p>Article text and images remain the property of their respective rights holders, including Guardian News &amp; Media. Site design and original materials are owned by {brand.site_name}.</p>
            </Section>
            <Section title="7. Disclaimer & Limitation of Liability">
                <p>The site is provided "as is" without warranties of any kind. To the fullest extent permitted by law, {brand.site_name} shall not be liable for any damages arising from your use of the site or reliance on its content.</p>
            </Section>
            <Section title="8. Contact">
                <p>Questions about these terms? Email us at {brand.support_email}.</p>
            </Section>
        </div>
    );
}
